import {Component, Input} from '@angular/core';
import {TaskModel} from '../../../../../models/task.model';

@Component({
    selector: 'app-tasks-view-calendar',
    templateUrl: './tasks-view-calendar.component.html',
    styleUrl: './tasks-view-calendar.component.scss'
})
export class AppTasksViewCalendarComponent {
    @Input() taskData: TaskModel[];
    @Input() title: string
}